import React, { useEffect, useState } from 'react';

import styled from '@emotion/styled';

import { FormSubmitButton } from '../../../components/Button/FormSubmitButton';
import PreviousSubmitBtn from '../../../components/Button/PreviousSubmitBtn';
import {
  CustomCheckbox,
  CustomCheckboxGroup,
} from '../../../components/FormCom/CustomCheckBoxField';
import { FormComponent } from '../../../components/FormCom/FormComponent';
import { HideableTextWithOutErrorMsgFormField } from '../../../components/FormCom/HideableTextWithOutErrorMsgFormField';
import { PasswordStrengthViewer } from '../../../components/FormCom/PasswordStrengthIndicator';
import { TranslatingContainerContext } from '../../../components/TranslatingContainer/TranslatingContainerProvider';
import useSignup from '../../../hooks/auth/admin/useSignup';
import {
  SignUpPasswordDataType,
  signUpPasswordInitialValues,
  SignUpPasswordSchema,
} from '../../../models/auth/signUp/signUpPassword.model';
import { signUpActions } from '../../../redux/slices/signUpSlice';
import { useAppDisPatch } from '../../../redux/store';

const SignUpPasswordForm = () => {
  const dispatch = useAppDisPatch();
  const { sliderIndex } = React.useContext(TranslatingContainerContext)!;

  const { loading, signup } = useSignup();
  const [triggerSubmit, setTriggerSubmit] = useState<Boolean>(false);

  useEffect(() => {
    if (triggerSubmit) {
      signup();
      setTriggerSubmit(false);
    }
    // eslint-disable-next-line
  }, [triggerSubmit]);

  const onSubmit = (value: SignUpPasswordDataType) => {
    dispatch(signUpActions.setPasswordSlider(value));
    // signup();
    setTriggerSubmit(true);
  };

  return (
    <Container sliderIndex={sliderIndex}>
      <FormComponent
        initialValues={signUpPasswordInitialValues}
        schema={SignUpPasswordSchema}
        onSubmit={onSubmit}
      >
        <HideableTextWithOutErrorMsgFormField
          label='Password'
          name='password'
          type='password'
          id='password'
          placeholder='Password'
        />

        <PasswordStrengthViewer passwordName='password' />

        {sliderIndex === 3 && (
          <FormFooter>
            <CustomCheckboxGroup name='terms' doNotShowError>
              <CustomCheckbox value='terms' />
            </CustomCheckboxGroup>
            I accept, logirate's <SpanLinks>Terms of Use</SpanLinks> and{' '}
            <SpanLinks>Privacy </SpanLinks> Policy
          </FormFooter>
        )}

        <FormButtonArea>
          <PreviousSubmitBtn>Go Back</PreviousSubmitBtn>
          <FormSubmitButton loading={loading} className='large'>
            Submit
          </FormSubmitButton>
        </FormButtonArea>
      </FormComponent>
    </Container>
  );
};

export default SignUpPasswordForm;

interface ContainerProp {
  sliderIndex: number;
}

const Container = styled.div<ContainerProp>`
  width: 400px;
  flex-direction: column;
  display: ${({ sliderIndex }) => (sliderIndex >= 3 ? 'flex' : 'none')};

  @media (max-width: 884px) {
    width: 100%;
    max-width: 400px;
  }
`;

const FormButtonArea = styled.div`
  display: grid;
  grid-template-columns: 120px auto;
  gap: 24px;
  margin-top: 12px;
`;

const FormFooter = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  text-align: center;
  color: ${({ theme }) => theme.palette.formFooterText};
  margin-bottom: -12px;
  margin-top: 118px;

  @media (max-width: 884px) {
    gap: 0px;
  }
`;

const SpanLinks = styled.span`
  cursor: pointer;
  color: ${({ theme }) => theme.palette.logiratePrimary};
  font-weight: 600;
  margin-left: 4px;
  margin-right: 4px;
`;
